import { get } from 'lodash-es';
import isBrowserInFullScreenMode from '../utils/isBrowserInFullScreenMode';
export function getOpenInMobileProps(state) {
    var projectID = get(state, 'project.config.id');
    return {
        isVisible: isVisible(state),
        projectID: projectID,
    };
}
function isVisible(state) {
    return (!isBrowserInFullScreenMode() &&
        !state.project.hideOpenInMobile &&
        !state.project.isDownloaded &&
        state.deviceDetection.isIOS &&
        state.openInMobileVisible &&
        state.project.config.isNavigationEnabled);
}
